/*eslint-disable*/
import { Flex, Link, Text } from "@chakra-ui/react";
import React from "react";

export default function Footer(props) {
  // const linkTeal = useColorModeValue("teal.400", "red.200");=
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="space-between"
      px="30px"
      pb="20px"
    >
      <Text
        color="gray.400"
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}
      >
        &copy; {1900 + new Date().getYear()},{" "}
        <Text as="span">
          Made by  
        </Text>
        <Link
          // color={linkTeal}
          color="teal.400"
          href="https://www.facebook.com/theKiddschool/"
          target="_blank"
          ml='2px'
        >
          โรงเรียนกวดวิชาคิดดี
        </Link>
      </Text>
    </Flex>
  );
}
